import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import TitleBar from "../_common/TitleBar";
import Table from "../_common/Table";
import { actionScripts } from "../../_helpers/actionScripts";

class CommentKeywordReport extends Component {
  state = {
    sortColumn: { path: "reportStartDate", order: "asc" },
  };

  columns = [
    {
      label: "Diary Date",
      path: "reportStartDate",
    },
    { label: "Comment Subject", path: "commentSubject" },
    {
      label: "Comment Narrative",
      path: "commentNarrative",
      action: "FETCH_ADR",
    },
  ];

  handleSort = (sortColumn) => this.setState({ sortColumn });
  handleClick_tr = (adr) => {
    const { tab } = this.props;
    actionScripts.FETCH_ADR.run(tab.projectId, adr.assistantDailyReportId);
  };

  getData = () => {
    const { sortColumn } = this.state;
    const { report } = this.props;
    return _.orderBy(
      report.commentKeywordReportData,
      [sortColumn.path],
      [sortColumn.order]
    );
  };

  render() {
    const { report } = this.props;
    const data = report.commentKeywordReportData ? this.getData() : [];
    return (
      <React.Fragment>
        <TitleBar titleText={"Comment Keyword Report"} />
        <div className="card mx-2">
          <div className="card-body">
            <h3>Comment Keyword Report</h3>
            <div className="form-row form-group">
              <label className="col-sm-3 col-form-label">Report created on:</label>
              <div className="col-sm-5">
                <input
                  type="text"
                  disabled
                  className="form-control"
                  value={report.created}
                />
              </div>
            </div>
            <div className="form-row form-group">
              <label className="col-sm-3 col-form-label">Report remarks:</label>
              <div className="col-sm-5">
                <textarea className="form-control" rows={3} />
              </div>
            </div>
            <div className="form-row form-group">
              <label className="col-sm-3 col-form-label">Keyword searched:</label>
              <div className="col-sm-5">
                <input
                  type="text"
                  disabled
                  className="form-control"
                  value={report.keywordTag}
                />
              </div>
            </div>
            <div className="form-row form-group">
              <label className="col-sm-9" />
            </div>
            <Table
              className="table table-hover"
              columns={this.columns}
              data={data}
              idPropName={"assistantDailyReportId"}
              idPropName2="commentId"
              sortColumn={this.state.sortColumn}
              onSort={this.handleSort}
              handleClick_tr={this.handleClick_tr}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  report: state.reports.openReports[ownProps.tab.tabId],
});

export default connect(mapStateToProps)(CommentKeywordReport);
